import Head from "next/head";
import React from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import webBanner from "../public/images/page_banner/riverside_web.jpg";
import mobBanner from "../public/images/page_banner/riverside_mob.jpg";
import Image from "next/image";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import RiversideTestimonial from "@/components/RiversideTestimonial";
import axios from "axios";
import qs from "qs";
import Seo from "@/components/seo/Seo";

const Riversideapartments = ({ data }) => {
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
    Hash: false,
  });
  const seo = data?.attributes?.seo;

  return (
    <>
      <Seo seo={seo} />
      <section
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
      >
        <div className="carousel-inner overlaybg">
          <div className="carousel-item active" data-bs-interval="10000">
            <Image
              src={webBanner}
              className="d-none d-md-block  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />

            <Image
              src={mobBanner}
              className="d-block d-md-none  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
            <div className="banner-wrap">
              <div className="d-flex align-items-center justify-content-center">
                <h1 className="banner-title text-white">
                  Riverside Ganga Facing Flats
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sec-padd water_mark">
        <Container>
          <div className="inner_text text-center">
            <Row className="justify-content-center">
              <Col md={12}>
                <div
                  className="head_wrap"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="1000"
                >
                  <div className="center-title">
                    <h2 className="section-title">
                      New Kolkata - The Riverside Project With Ganga Facing
                      Flats
                    </h2>
                  </div>
                </div>
                <p
                  className="mb-0"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Residents of the{" "}
                  <sstrong>New Kolkata Riverside Project</sstrong> will have the
                  luxury of waking up to a scenic riverside view from their
                  homes. New Kolkata’s record number of{" "}
                  <sstrong>Ganga facing flats in North Kolkata</sstrong> gives
                  their residents an unparallel view of the mighty river. The{" "}
                  <sstrong>New Kolkata Riverside Project</sstrong> gives their
                  owners all modern amenities while nestled in the lap of
                  nature. Being built close to the holy river, the{" "}
                  <sstrong>Ganga facing flats in North Kolkata</sstrong> is also
                  Vaastu compliant – thus ‘Home by the Ganges’ offers plenty of
                  happiness and prosperity into the lives of the residents.
                </p>
                <div className="mt-30">
                  <div
                    className="head_wrap"
                    data-aos="fade-up"
                    data-aos-delay="300"
                    data-aos-duration="1000"
                  >
                    <div className="center-title">
                      <h2 className="section-title">
                        IGBC Green Affordable Housing
                      </h2>
                    </div>
                  </div>
                  <p
                    className="mb-0"
                    data-aos="fade-up"
                    data-aos-delay="400"
                    data-aos-duration="1000"
                  >
                    While rapid urbanisation, growing cities provide various
                    opportunities, but also there are many drawbacks in terms of
                    proliferation of slums, high prices of land and building
                    materials which render houses unaffordable for the lower
                    income group of people. Therefore, the need for adequate
                    housing for the low-income groups will substantially
                    increase. Most importantly, while we create housing for
                    these sections of the society, they need to be green too.
                  </p>
                </div>
                <div className="sec-padd-top">
                  <div
                    className="head_wrap"
                    data-aos="fade-up"
                    data-aos-delay="300"
                    data-aos-duration="1000"
                  >
                    <div className="center-title">
                      <h2 className="section-title">
                        New Kolkata Ghat Launch with Ganga Aarti
                      </h2>
                    </div>
                  </div>
                  <Row className="justify-content-center">
                    <Col md={8}>
                      <div className="video">
                        <div className="img-wrap image-container gall_wrp">
                          <div
                            data-fancybox="construction"
                            data-src="https://www.youtube.com/embed/1fUE944-UZg"
                            className="img_overlay"
                          >
                            <Image
                              fill
                              src="/images/newkolkata/ganga-aarti.jpg"
                              alt="interior"
                              className="image"
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section className="sec-padd blue_patch">
        <Container>
          <div
            className="head_wrap text-center pb-2"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="1000"
          >
            <div className="center-title white_border text-white">
              <h2 className="section-title mb-0">
                Why is New Kolkata the Perfect Riverside Project?
              </h2>
              <p>
                The New Kolkata Riverside Project promises to deliver a
                cost-effective and unique lifestyle for everyone through the
                following points;
              </p>
            </div>
          </div>
          <div className="mt-30 text-white">
            <Row className="justify-content-center">
              <Col md={5}>
                <ul
                  className="ul-list"
                  data-aos="fade-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  <li>
                    A fresh airy and light-filled home by the beautiful Ganges.
                  </li>
                  <li>
                    A private Jetty and Ferry service exclusively for the
                    residents.
                  </li>
                  <li>
                    The most Affordable flats by the banks of the Holy river.
                  </li>
                </ul>
              </Col>
              <Col md={5}>
                <ul
                  className="ul-list"
                  data-aos="fade-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  <li>Access to the private Ganga Ghat and Temple</li>
                  <li>3-way connectivity by road, rail, and river.</li>
                  <li>
                    4-way connectivity with access to the Dakshineshwar metro.
                  </li>
                </ul>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <RiversideTestimonial />
    </>
  );
};

export default Riversideapartments;
export async function getServerSideProps() {
  try {
    const query = {
      populate: ["*", "seo", "seo.metaImage", "seo.schema"],
    };

    /** If we are loading projects from anywhere other than the home page, then we load the configuration information also. */

    const queryString = qs.stringify(query, {
      encodeValuesOnly: true,
    });

    const endpoint = `${process.env.NEXT_PUBLIC_BACKEND_API_URL}/api/riverside-apartment?${queryString}`;
    // console.log(`Final url: ${endpoint}`);

    const response = await axios.get(endpoint);
    const data = response.data.data;
    // Pass data to the page via props
    return {
      props: { data },
    };
  } catch (error) {
    console.log("Error", error);
  }
}
